// src/pages/Wishlist.js
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../styles/Wishlist.css';
import filmsData from '../data/movies.json';

const Wishlist = () => {
  // Pour l'exemple, on simule une wishlist contenant les IDs de films
  const [wishlist, setWishlist] = useState([1, 3]);

  // Filtrer les films correspondant aux IDs dans la wishlist
  const wishlistFilms = filmsData.filter(film => wishlist.includes(film.id));

  return (
    <div className="wishlist-page">
      <h1>Ma Wishlist</h1>
      {wishlistFilms.length > 0 ? (
        <div className="wishlist-grid">
          {wishlistFilms.map(film => (
            <div key={film.id} className="wishlist-card">
              <Link to={`/film/${film.id}`}>
                <img src={film.poster} alt={film.titre} />
                <h2>{film.titre}</h2>
              </Link>
            </div>
          ))}
        </div>
      ) : (
        <p>Votre wishlist est vide. Ajoutez des films que vous souhaitez voir !</p>
      )}
    </div>
  );
};

export default Wishlist;
